import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="problem_smack">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/smackback/prob.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={738}
              height={929}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            className="my-auto offset-lg-1 order-md-2 order-1"
          >
            <h2>The Problem</h2>
            <p>
              We often hear people complain about not being able to reply to
              texts. Messages in group chats keep on piling up, and at times you
              are just busy and unable to respond. Not being able to get back to
              people can become the cause of anxiety for you as well as for the
              people who are trying to reach you. Many of us prefer
              communicating through text messages instead of having to call. But
              as the overall lifestyle of people have changed and most of us are
              almost always on the go, keeping up with texting has become a
              challenge. So in an age where digital solutions for every
              imaginable problem exists, why haven't tech leaders figured out a
              way yet to solve this common problem?
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
